import classnames from 'classnames';
import * as cssUtils from '../../utils/css-utils';
import { isFooterHidden } from '../get-footer';
export function getAdSection({ css, lpProps, composerData, }) {
    if (lpProps.showAd === true) {
        const rules = [css['so-global-region-footer'], css['so-global-region']];
        const mobileCssClass = cssUtils.getRegionMobileCssClass(rules);
        const bottomCss = cssUtils.getBottomPaddingRestrictionCssClass(rules);
        const margin = cssUtils.margin(rules);
        const padding = cssUtils.padding(rules);
        const footerHidden = isFooterHidden(composerData);
        margin.top = footerHidden ? 15 : 0;
        padding.top = 0;
        return {
            cssClass: classnames(mobileCssClass, bottomCss),
            outerPadding: margin,
            innerPadding: padding,
        };
    }
    return null;
}
//# sourceMappingURL=get-ad-section.js.map